import { Clock, Phone, Activity, MessageCircle, Moon } from "lucide-react";

export default function DayTimelineSection() {
  const timeline = [
    {
      time: "7:00 AM",
      icon: MessageCircle,
      action: "Morning message",
      description: "Focus question for the day",
    },
    {
      time: "9:30 AM",
      icon: Phone,
      action: "Pre-meeting call",
      description: "3-min goal alignment",
    },
    {
      time: "1:15 PM",
      icon: Activity,
      action: "Biomarker alert",
      description: "Calm-down and refocus",
    },
    {
      time: "4:00 PM",
      icon: Clock,
      action: "Quick check-in",
      description: "Mid-day adjustment",
    },
    {
      time: "8:30 PM",
      icon: Moon,
      action: "Evening voicemail",
      description: "Reflect + reset",
    },
  ];

  return (
    <section className="py-24 md:py-32 bg-background">
      <div className="container mx-auto px-4 md:px-8 xl:px-12">
        <div className="max-w-6xl mx-auto">
          {/* Header */}
          <div className="text-center space-y-12 mb-20">
            <div className="space-y-6">
              <span className="text-primary text-sm font-bold tracking-wider uppercase">
                DAILY SUPPORT SYSTEM
              </span>
              <h2 className="text-3xl md:text-5xl xl:text-6xl font-bold md:font-extrabold leading-[0.9] tracking-tighter text-foreground max-w-4xl mx-auto">
                A day with <span className="text-primary">1440's support:</span>
              </h2>
            </div>
            <div className="w-24 h-1 bg-primary mx-auto"></div>
          </div>

          {/* Timeline */}
          <div className="space-y-8 md:space-y-12">
            {timeline.map((item, index) => (
              <div key={index} className="group relative">
                {/* Mobile Timeline Layout */}
                <div className="flex items-start gap-4 md:hidden">
                  {/* Left side - Time and Icon */}
                  <div className="flex flex-col items-center">
                    <div className="text-lg font-black text-primary font-mono mb-2">
                      {item.time}
                    </div>
                    <div className="w-12 h-12 border-2 border-border bg-card flex items-center justify-center group-hover:border-primary group-hover:bg-primary transition-colors">
                      <item.icon className="w-6 h-6 text-foreground group-hover:text-black" />
                    </div>
                    {/* Connecting line for mobile */}
                    {index < timeline.length - 1 && (
                      <div className="w-px h-8 bg-border mt-4"></div>
                    )}
                  </div>

                  {/* Right side - Content */}
                  <div className="flex-1 pt-1">
                    <h3 className="text-lg font-bold text-foreground mb-1">
                      {item.action}
                    </h3>
                    <p className="text-base text-muted-foreground">
                      {item.description}
                    </p>
                  </div>
                </div>

                {/* Desktop Layout */}
                <div className="hidden md:grid lg:grid-cols-12 gap-6 lg:gap-8 items-center">
                  {/* Time */}
                  <div className="lg:col-span-2">
                    <div className="text-2xl lg:text-3xl font-black text-primary font-mono">
                      {item.time}
                    </div>
                  </div>

                  {/* Icon */}
                  <div className="lg:col-span-2">
                    <div className="w-16 h-16 lg:w-20 lg:h-20 border-2 border-border bg-card flex items-center justify-center group-hover:border-primary group-hover:bg-primary transition-colors">
                      <item.icon className="w-8 h-8 lg:w-10 lg:h-10 text-foreground group-hover:text-black" />
                    </div>
                  </div>

                  {/* Content */}
                  <div className="lg:col-span-8 space-y-3">
                    <div className="flex items-center gap-4">
                      <h3 className="text-xl lg:text-2xl xl:text-3xl font-bold text-foreground">
                        {item.action}
                      </h3>
                      <div className="hidden lg:block flex-1 h-px bg-border"></div>
                    </div>
                    <p className="text-lg lg:text-xl text-muted-foreground">
                      {item.description}
                    </p>
                  </div>
                </div>

                {/* Desktop connecting line */}
                {index < timeline.length - 1 && (
                  <div className="hidden md:block lg:col-start-3 lg:ml-10 w-px h-12 bg-border my-8"></div>
                )}
              </div>
            ))}
          </div>

          {/* Bottom statement */}
          <div className="text-center mt-20 pt-12 border-t-2 border-border">
            <p className="text-2xl xl:text-3xl font-bold text-foreground">
              → All automated. All personalized. All based on your{" "}
              <span className="text-primary">data.</span>
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
